import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  RouterProvider,
  createBrowserRouter,
} from 'react-router';
import '../theme/scss/styles.scss';
import { isMobile } from 'react-device-detect';
import { responseLogWithNotification } from '../utils/utils';
import { getLayoutByRole, getRouteByRole, calculateBaseRoute } from '../utils/routeByRoles';
import { endLoadApp, initApp } from '../modules/System/actions';
import { getAuthorizedData } from '../modules/Authorized/reducer';
import ErrorPage from '../modules/System/components/ErrorPage';

export default function Main() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    loggedIn, authorizedData, loadingAuthorizedCheck, loginProcess,
  } = useSelector(getAuthorizedData);
  const permissions = authorizedData && authorizedData.role && authorizedData.role.permissions ? authorizedData.role.permissions : {};

  useEffect(() => {
    dispatch(initApp());
    document.title = formatMessage({ id: 'app.title' });
    // if (loggedIn) {
    //   dispatch(authorizedCheck())
    //     .then(() => {
    //       setTimeout(() => { dispatch(endLoadApp()); }, 800);
    //     })
    //     .catch(responseLogWithNotification);
    // } else if (!loginProcess && !loadingAuthorizedCheck) {
    dispatch(endLoadApp());
    // }
  }, [dispatch, loggedIn, formatMessage]);

  const currentRoutes = getRouteByRole(loggedIn, permissions, null, isMobile);
  const currentRoutesByMenu = getRouteByRole(loggedIn, permissions, null, isMobile, true);
  const CurrentLayout = getLayoutByRole(loggedIn, isMobile);
  calculateBaseRoute(true, permissions, null, isMobile, true);
  const routes = currentRoutes.reduce((acc, currentRoute) => {
    const route = { ...currentRoute };
    if (currentRoute && currentRoute.children && currentRoute.children.length) {
      route.children = [];
      return [...acc, ...currentRoute.children, route];
    }
    return [...acc, route];
  }, []);
  const router = createBrowserRouter([
    {
      element: <CurrentLayout currentRoutes={currentRoutes} currentRoutesByMenu={currentRoutesByMenu} />,
      children: routes,
      errorElement: <ErrorPage />,
    },
  ]); // todo по идее можно сделать разделение всех страниц по своим лаяутам. Но вот например у некоторых урлов может быть разные лаяуты
  return (
    <RouterProvider router={router} />
  );
}
